"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileUploadLabelButtonStyle = void 0;
var _react = _interopRequireDefault(require("react"));
var _formFieldPropTypes = require("../../../../../propTypes/formFieldPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FileUploadLabelButtonStyle = _ref => {
  let {
    buttonCssClass = 'button primary',
    maxFileCount = 8,
    maxFileSize = '10mb',
    restrictionsTxt = '.doc & .txt not allowed',
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "fileUploadLabelButtonStyle"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: buttonCssClass,
    onClick: onClick
  }, "Select file/s"), "or", /*#__PURE__*/_react.default.createElement("br", null), "Drag and drop your file/s here", /*#__PURE__*/_react.default.createElement("span", {
    className: "fileUploadRestrictions"
  }, /*#__PURE__*/_react.default.createElement("em", null, "Maximum ", maxFileCount, " files"), /*#__PURE__*/_react.default.createElement("em", null, "Max file size ", maxFileSize), /*#__PURE__*/_react.default.createElement("em", null, restrictionsTxt)));
};
exports.FileUploadLabelButtonStyle = FileUploadLabelButtonStyle;
FileUploadLabelButtonStyle.propTypes = _formFieldPropTypes.FileUploadLabelStyleButtonPropTypes;